module.exports = __webpack_public_path__ + "static/media/hublot_logo.fb425e03.svg";